import Abstract from "../../abstract-view/abstract.js";

export default class Header extends Abstract {
  constructor(element) {
    super();

    this._element = element;
    this._menuList = null;
    this._catalogButton = null;
    this._lastMenuItem = null;
    this._addressButton = null;
    this._searchFormElement = null;
    this._headerListElement = null;

    this._defaultAddressButtonText = null;
  }

  getMenuList() {
    if (!this._menuList) {
      this._menuList = this._element.querySelector(`.header-menu-list`);
    }

    return this._menuList;
  }

  getLastMenuItem() {
    if (!this._lastMenuItem) {
      this._lastMenuItem = this._element.querySelector(`.header-menu-list__item:last-child`);
    }

    return this._lastMenuItem;
  }

  getHeaderListElement() {
    if (!this._headerListElement) {
      this._headerListElement = this._element.querySelector(`.header-list_catalog`);
    }

    return this._headerListElement;
  }

  getCatalogButton() {
    if (!this._catalogButton) {
      this._catalogButton = this._element.querySelector(`.header-list__item_button`);
    }

    return this._catalogButton;
  }

  getAddressButton() {
    if (!this._addressButton) {
      this._addressButton = this._element.querySelector(`.header-address-button`);
    }

    return this._addressButton;
  }

  getSearchFormElement() {
    if (!this._searchFormElement) {
      this._searchFormElement = this._element.querySelector(`.header-list__item_search-form`);
    }

    return this._searchFormElement;
  }

  getCategories() {
    return this._element.querySelectorAll(`.header-menu-list__link_category`);
  }

  changeAddressButtonText(text) {
    const button = this.getAddressButton();

    this._defaultAddressButtonText = button.textContent.trim();

    button.textContent = text;
  }

  resetAddressButtonText() {
    this.getAddressButton().textContent = this._defaultAddressButtonText;
  }
}
